import routesEditComponent from './routes.edit.component';

let routesEditModule = angular.module('routesedit', [
	])

	.component('routesedit', routesEditComponent)

	.name;

export default routesEditModule;


// WEBPACK FOOTER //
// ./client/app/components/routes/edit/index.js